import { IapService } from '../../services/iap.service';
import { Team } from '../../models/team.model';
import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  OnChanges,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastController, IonInput } from '@ionic/angular';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Validators } from '@angular/forms';
import { AppTrial } from '../../models/app-trial.model';

@Component({
  selector: 'avatar-initials',
  templateUrl: './avatar-initials.component.html',
  styleUrls: ['./avatar-initials.component.scss'],
})
export class AvatarInitialsComponent implements OnInit {
  @Input() slot: string;
  @Input() id: string;
  @Input() initials: string;
  hslColor: Object; // = { 'background-color': 'red'};

  aColor: string;
  constructor() {}

  ngOnInit() {
    //console.log('avatar-initials');
    //console.log('slot:     ' + this.slot );
    //console.log('id:       ' + this.id );
    //console.log('initials: ' + this.initials );

    const hsl = this.stringToHslColor(this.id, 44, 66);

    this.hslColor = { 'background-color': hsl };
  }

  stringToHslColor(str, s, l) {
    if (typeof str === 'undefined' || str === null) {
      return 'hsl(0, 100%, 100%)';
    } else {
      const hash = str.charCodeAt(str.length - 1) * 14;
      const h = hash % 360;

      return 'hsl(' + h + ', ' + s + '%, ' + l + '%)';
    }
  }
}
